module.exports = __webpack_public_path__ + "img/filter-sort-down.52d79e4f.svg";